import 'css-chunksrc/client/pages/notificationsPage/styles.scss';export default {
  "notifications": "_notifications_1decm_1",
  "header": "_header_1decm_8",
  "title": "_title_1decm_17",
  "profileNavigation": "_profileNavigation_1decm_21",
  "main": "_main_1decm_29",
  "list": "_list_1decm_38",
  "item": "_item_1decm_42",
  "placeholder": "_placeholder_1decm_47"
};